<template>
    <table class="fixRotationReverse">
        <tr>
            <td>
            <i class = "fas fa-check"></i>
            </td>
            <td>
             {{ $t("home.costiTableRegistrazione") }}
            </td>
            <td>
            199 <b class="green-text">USDT</b>
            </td>
        </tr>
        <tr>
            <td>
            <i class = "fas fa-check"></i>
            </td>
            <td>
            {{ $t("home.costiTableAssistenzaVIP") }} <span class="yellow-text">*</span>
            </td>
            <td>
            100 <b class="green-text">USDT</b>
            </td>
        </tr>
        <tr>
            <td>
            <i class = "fas fa-check"></i>
            </td>
            <td>
            {{ $t("home.costiTableRivenditaMarketplace") }}
            </td>
            <td>
            5%
            </td>
        </tr>
        <tr>
            <td>
            <i class = "fas fa-check"></i>
            </td>
            <td>
            Gas <span class="yellow-text">**</span>
            </td>
            <td>
            ~ 1$
            </td>
        </tr>
    </table>

</template>

<script>

</script>

<style>
    tr{
        border-bottom: 1px solid white !important;
    }
</style>
